import React, { FC } from 'react';
import { Control, FieldError, useController } from 'react-hook-form';

import {
  StyledBlock,
  StyledCheckbox,
  StyledErrorMessage,
  StyledInput,
} from './styled';

interface CheckBoxV2Props {
  label?: string | JSX.Element;
  disabled?: boolean;
  name: string;
  error?: FieldError;
  width?: string;
  indeterminate?: boolean;
  labelStyles?: { [key: string]: any };
  zoom?: number;
  control: Control;
  onClick?: () => void;
  checkBoxWidth?: string;
}

const CheckBoxV2: FC<CheckBoxV2Props> = ({
  label = '',
  disabled = false,
  name,
  error,
  width,
  indeterminate,
  labelStyles,
  zoom = 1,
  control,
  onClick,
  checkBoxWidth,
}) => {
  const { field } = useController({
    name,
    control,
  });

  return (
    <StyledBlock
      className={disabled && 'disabled'}
      width={width}
      labelStyles={labelStyles}
      zoom={zoom}
      onClick={onClick}
    >
      <StyledInput
        type="checkbox"
        checked={field.value}
        disabled={disabled}
        onChange={(e) => field.onChange(e.target.checked)}
        indeterminate={indeterminate}
        zoom={zoom}
        checkBoxWidth={checkBoxWidth}
      />
      <StyledCheckbox zoom={zoom} size={checkBoxWidth} />
      {label}
      {error && (
        <StyledErrorMessage zoom={zoom}>{error.message}</StyledErrorMessage>
      )}
    </StyledBlock>
  );
};

export default CheckBoxV2;
